var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 27V33H13.3333V27H20ZM33.3333 27V33H26.6667V27H33.3333ZM46.6667 27V33H40V27H46.6667ZM53.3333 6C55.1014 6 56.7971 6.63214 58.0474 7.75736C59.2976 8.88258 60 10.4087 60 12V54C60 55.5913 59.2976 57.1174 58.0474 58.2426C56.7971 59.3679 55.1014 60 53.3333 60H6.66667C2.96667 60 0 57.3 0 54V12C0 10.4087 0.702379 8.88258 1.95262 7.75736C3.20286 6.63214 4.89856 6 6.66667 6H10V0H16.6667V6H43.3333V0H50V6H53.3333ZM53.3333 54V21H6.66667V54H53.3333ZM20 39V45H13.3333V39H20ZM33.3333 39V45H26.6667V39H33.3333ZM46.6667 39V45H40V39H46.6667Z",
    fill: "#004D93"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.3b3fb93867f01c34a146b5c97f315406.svg";
export { ForwardRef as ReactComponent };